import { createRoute, redirect } from '@tanstack/react-router'

import { DEFAULT_KIT_SEARCH } from './kits.tsx'
import { parsePositiveInt } from './params.ts'
import { pitchListLink } from './pitches.tsx'
import { rootRoute } from './root.tsx'

// Gateway and Banco were one thing in two sections until 20.10.2026: a bookmark to either
// lands on the kits. docs/decisioni/un-kit-si-riconosce-dal-numero.md

interface Legacy {
  readonly params: { readonly id?: string }
}

/** A kit's record when the old path named one, the kits otherwise (`/gateways/new` included). */
function toKits({ params }: Legacy): never {
  const id = parsePositiveInt(params.id)
  if (id === null) throw redirect({ to: '/kits', search: DEFAULT_KIT_SEARCH, replace: true })
  throw redirect({ to: '/kits/$id', params: { id }, replace: true })
}

function toPitchKits({ params }: Legacy): never {
  const id = parsePositiveInt(params.id)
  if (id === null) throw redirect({ ...pitchListLink, replace: true })
  throw redirect({ to: '/pitches/$id/kits', params: { id }, replace: true })
}

function legacy(path: string, beforeLoad: (context: Legacy) => never) {
  return createRoute({ getParentRoute: () => rootRoute, path, beforeLoad })
}

export const LEGACY_KIT_ROUTES = [
  legacy('/gateways', toKits),
  legacy('/bench', toKits),
  legacy('/gateways/$id', toKits),
  legacy('/pitches/$id/gateways', toPitchKits),
] as const
